// extracted by extract-css-chunks-webpack-plugin
module.exports = {"AvatarPlaceholder":"L7fIUbgD","letters":"TPe_i55p"};